module.exports = __webpack_public_path__ + "static/world-img.7619762d.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/world-img.svg
// module id = 555
// module chunks = 0